import React from 'react'
import { View } from 'oio-react'

const TypographySpecimen1 = () => (
   <View position="relative" textAlign="left">
      <h1>
         Heading 1
         <span className="label">H1</span>
      </h1>
      <h2>
         Heading 2
         <span className="label">H2</span>
      </h2>
      <h3>
         Heading 3
         <span className="label">H3</span>
      </h3>
      <h4>
         Heading 4
         <span className="label">H4</span>
      </h4>
      <p className="subtitle">
         This is a Subtitle
         <span className="label">Subtitle</span>
      </p>
      <p>
         <span className="label">Body</span>
         <b>This is sample body text.</b>
         {'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'}
      </p>
   </View>
)

export default TypographySpecimen1
